import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const TooltipWrapper = ({ children, tooltipText, placement = 'right', delayShow = 300, delayHide = 150 }) => {
  if (!tooltipText) {
    return children;
  }

  const tooltip = <Tooltip id={`tooltip-${Math.random()}`}>{tooltipText}</Tooltip>;

  return (
    <OverlayTrigger overlay={tooltip} placement={placement} delayShow={delayShow} delayHide={delayHide}>
      {children}
    </OverlayTrigger>
  );
};

export default TooltipWrapper;
